// Carry Roll Brent's method — root finding (P3.1.1).
// Pure function, no engine/UI dependencies.
/**
 * Brent's method root-finding. Finds x in [a,b] where f(x) = 0.
 * Requires f(a) and f(b) have opposite signs.
 * Returns the root or null if no sign change / not found within maxIter.
 */
export function brent(f, a, b, tol = 1e-6, maxIter = 100) {
    let fa = f(a);
    let fb = f(b);
    if (fa === 0)
        return a;
    if (fb === 0)
        return b;
    if (fa * fb > 0)
        return null; // no sign change
    if (Math.abs(fa) < Math.abs(fb)) {
        [a, b] = [b, a];
        [fa, fb] = [fb, fa];
    }
    let c = a;
    let fc = fa;
    let mflag = true;
    let d = b;
    for (let i = 0; i < maxIter; i++) {
        if (fb === 0)
            return b;
        if (fa * fc > 0) {
            // secant step
            c = a;
            fc = fa;
            d = b;
            mflag = true;
        }
        else {
            mflag = false;
        }
        let s;
        if (fa !== fc && fb !== fc) {
            // inverse quadratic interpolation
            s =
                (a * fb * fc) / ((fa - fb) * (fa - fc)) +
                    (b * fa * fc) / ((fb - fa) * (fb - fc)) +
                    (c * fa * fb) / ((fc - fa) * (fc - fb));
        }
        else {
            // secant method
            s = b - (fb * (b - a)) / (fb - fa);
        }
        // Check if s is acceptable; otherwise use bisection
        const lo = Math.min((3 * a + b) / 4, b);
        const hi = Math.max((3 * a + b) / 4, b);
        const cond1 = !(s > lo && s < hi);
        const cond2 = mflag && Math.abs(s - b) >= Math.abs(b - c) / 2;
        const cond3 = !mflag && Math.abs(s - b) >= Math.abs(c - d) / 2;
        if (cond1 || cond2 || cond3) {
            s = (a + b) / 2; // bisection
            mflag = true;
        }
        else {
            mflag = false;
        }
        const fs = f(s);
        d = c;
        c = b;
        fc = fb;
        if (fa * fs < 0) {
            b = s;
            fb = fs;
        }
        else {
            a = s;
            fa = fs;
        }
        if (Math.abs(b - a) < tol)
            return b;
        if (Math.abs(fa) < Math.abs(fb)) {
            [a, b] = [b, a];
            [fa, fb] = [fb, fa];
        }
    }
    return b;
}
//# sourceMappingURL=brent.js.map